<script setup>
//import { ref } from "vue";
import { storeToRefs } from "pinia";
import { useCotizacionEstandarStore } from "@/store/cotizaciones/estandar";
import useCotizacionEstandarLeaseParametersStore from "@/store/cotizaciones/estandar/lease-parameters";

const { stateCalculosLeaseParameters, state } = storeToRefs(
  useCotizacionEstandarStore()
);
const { leaseParameters } = storeToRefs(
  useCotizacionEstandarLeaseParametersStore()
);
</script>

<template>
  <div v-if="leaseParameters">
    {{ leaseParameters.vat }}
    <table
      class="table table-sm table-bordered text-xs table-striped table-hover"
    >
      <tbody>
        <tr>
          <th>Currency</th>
          <td>{{ state.monedaOperacion }}</td>
        </tr>
        <tr>
          <th>Blind Disc</th>
          <td>{{ leaseParameters.blindDisc }}%</td>
        </tr>
        <tr>
          <th>1st Rent Up Front</th>
          <td>{{ leaseParameters.rentUpFront }}%</td>
        </tr>
        <tr>
          <th>Delq Interest</th>
          <td>
            <input v-model="stateCalculosLeaseParameters.delq_interest" />%
          </td>
        </tr>
        <tr>
          <th>Equipment Value/Cost (OEC) - BEFORE BLIND DISCOUNT</th>
          <td>${{ leaseParameters.equipmentValueBeforeDes }}</td>
        </tr>
        <tr>
          <th>Equipment Value/Cost (OEC) - NET OF BLIND DISCOUNT</th>
          <td>${{ leaseParameters.equipmentValueBeforeNet }}</td>
        </tr>
        <tr>
          <th>Buy Out</th>
          <td>{{ leaseParameters.buyOut }}%</td>
        </tr>
        <tr>
          <th>RV %</th>
          <td>{{ leaseParameters.rvPorcentaje }}%</td>
        </tr>
        <tr>
          <th>RV Amount</th>
          <td>${{ leaseParameters.rvMonto }}</td>
        </tr>
        <tr>
          <th>Coupon</th>
          <td>{{ leaseParameters.coupon }}%</td>
        </tr>
        <tr>
          <th>Duration</th>
          <td>{{ leaseParameters.duration }}</td>
        </tr>
        <tr>
          <th>Down Payment % on Equipment</th>
          <td>{{ leaseParameters.downPaymentPorcentaje }}%</td>
        </tr>
        <tr>
          <th>Down Payment Amt on VAT</th>
          <td>${{ leaseParameters.downPaymentMonto }}</td>
        </tr>
        <tr>
          <th>Opening Fee %</th>
          <td>{{ leaseParameters.openingFeePorcentaje }}%</td>
        </tr>
        <tr>
          <th>Opening Fee Amt (basis = Equip Amt)</th>
          <td>${{ leaseParameters.openingFeeMonto }}</td>
        </tr>
        <tr>
          <th>VAT</th>
          <td><input v-model="stateCalculosLeaseParameters.vat" />%</td>
        </tr>
        <tr>
          <th>VAT Amt</th>
          <td>${{ leaseParameters.vatMonto }}</td>
        </tr>
        <tr>
          <th>VAT recouped at month</th>
          <td>{{ leaseParameters.vatRecoupedAtMonth }}</td>
        </tr>
        <tr>
          <th>Down Payment % on VAT</th>
          <td>{{ leaseParameters.downPaymentPorcentaje }}%</td>
        </tr>
        <tr>
          <th>Down Payment Amt on VAT</th>
          <td>${{ leaseParameters.downPaymentAmtVAT }}</td>
        </tr>
        <tr>
          <th>Withholding Tax</th>
          <td>
            <input v-model="stateCalculosLeaseParameters.withholdingTax" />%
          </td>
        </tr>
        <tr>
          <th>Facility Coupon / Cost of Capital</th>
          <td>
            <input v-model="stateCalculosLeaseParameters.facilityCoupon" />%
          </td>
        </tr>
        <tr>
          <th>NIM Margin Buffer (to flow into Reserve Acct)</th>
          <td>
            <input v-model="stateCalculosLeaseParameters.marginBuffer" />%
          </td>
        </tr>
        <tr>
          <th>FX</th>
          <td>{{ leaseParameters.fx }}</td>
        </tr>
        <tr>
          <th>FX as of</th>
          <td>
            <input type="date" v-model="stateCalculosLeaseParameters.fxAsOf" />
          </td>
        </tr>
        <tr>
          <th>Closing Date</th>
          <td><input type="date" v-model="state.fechaCierre" /></td>
        </tr>
        <tr>
          <th>First Payment Date</th>
          <td><input type="date" v-model="state.fechaPrimerVencimiento" /></td>
        </tr>
        <tr>
          <th>Monthly Rent Due Date</th>
          <td>{{ leaseParameters.monthlyRentDueDate }}</td>
        </tr>
        <!-- TODO:  Tomar fórmulas de Key Metrics -->
        <tr>
          <th>Monthly Interest During Grace Period</th>
          <td>Pendiente!!</td>
        </tr>
        <tr>
          <th>Servicing Fee</th>
          <td>
            <input v-model="stateCalculosLeaseParameters.servicingFee" />%
          </td>
        </tr>
        <tr>
          <th>Servicr Contribution</th>
          <td>
            <input
              v-model="stateCalculosLeaseParameters.serviceContribution"
            />%
          </td>
        </tr>
        <tr>
          <th>Partial Day Interest Rate</th>
          <td>{{ leaseParameters.partialDayInterestRate }}%</td>
        </tr>
        <tr>
          <th>Grace Period (Interest Only) Months</th>
          <td>
            <input v-model="stateCalculosLeaseParameters.gracePeriodMonths" />%
          </td>
        </tr>
        <tr>
          <th>Draw % of First Draw</th>
          <td><input v-model="stateCalculosLeaseParameters.firstDraw" />%</td>
        </tr>
        <tr>
          <th>Opening Fee + VAT</th>
          <td>${{ leaseParameters.openingFeeVAT }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scope>
input {
  background: rgb(247, 245, 245);
  border: 1px solid rgb(197, 197, 197);
  text-align: center;
  width: 50px;
  border-radius: 5px;
}

td {
  text-align: center;
}
</style>
